import {Dropdown as BaseDropdown, DropdownProps} from '../../control';
import {ElementStatus, useFormElementContext} from '../../form';
import {join} from '../../utils';
import {useCallback} from 'react';

import styles from './dropdown.module.less';

type Props = Omit<DropdownProps<any>, 'value' | 'setValue' | 'disabled' | 'validateOnBlur'>;

export function Dropdown(props: Props): JSX.Element {
	const context = useFormElementContext({array: true}, Dropdown);
	const ref = useCallback((r: any) => r && context.setRef(r.dropdownRef.current), [context.setRef]);

	return <BaseDropdown {...props}
	                     value={context.value}
	                     ref={ref}
	                     validateOnBlur={context.validateOnBlur}
	                     setValue={context.setValue}
	                     className={join(props.className, context.status === ElementStatus.invalid && styles.error)}
	                     aria-invalid={context.status === ElementStatus.invalid}
	                     disabled={context.status === ElementStatus.disabled}/>;
}

export {Option} from '../../control';
